import CONF from '@/Config.js';
import axios from 'axios';

export default {
    authInapp: function(type, id, ref, isPolicyAgreed, complexId)
    {

        // 모델하우스
        if(isPolicyAgreed === undefined)
        {
            var data = ref === null ? {
                payload: id
            } : {
                payload: id,
                referenceCode: ref
            }

            if (complexId !== undefined && complexId !== null) {
                data.complexId = complexId
            }

            return axios({
                method: 'post',
                url: CONF.AUTH_INAPP.replace("${type}", type),
                data: data
            })
        }
        else  // 일반 모델 (슬립큐, 엥자이랙스, 병원)
        {
            var data = ref === null ? {
                payload: id,
                isPolicyAgreed: isPolicyAgreed,
                phoneNumber: `${id.substring(0, 3)}-${id.substring(3, 7)}-${id.substring(7, 11)}`
            } : {
                payload: id,
                referenceCode: ref,
                isPolicyAgreed: isPolicyAgreed,
                phoneNumber: `${id.substring(0, 3)}-${id.substring(3, 7)}-${id.substring(7, 11)}`
            }

            if (complexId !== undefined && complexId !== null) {
                data.complexId = complexId
            }

            return axios({
                method: 'post',
                url: CONF.AUTH_INAPP.replace("${type}", type),
                data: data
            })

        }

    },
    fetchUserVisitInfos: function(uuid)
    {
        return axios({
            method: 'get',
            url: CONF.FETCH_USER_VISIT_INFOS.replace("${uuid}", uuid),
        })
    },
    fetchShortUrl: function(key)
    {
        return axios({
            method: 'get',
            url: `${CONF.FETCH_SHORT_URL}${key}`
        })
    },
    fetchHospitalInfos: function(uuid)
    {
        return axios({
            method: 'get',
            headers: {
                'Authorization': '.KK9vp3Kaa7pHU8Vvjx7BQg3xsVcU_'
            },
            url: CONF.FETCH_HOSPITAL_INFOS.replace("${uuid}", uuid)
        })
    },
    sendEventCode: function(eventName, eventCode, time)
    {
        var data = {
            bridgeCompany: "SLEEPQ",
            eventName: eventName,
            referenceCode: eventCode,
            timestamp: time
        }

        return axios({
            method: 'post',
            url: CONF.SEND_EVENT_CODE,
            data: data
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/tele.js